/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    $__0=    React,PropTypes=$__0.PropTypes,
    $__1=     require('react-dnd'),DragDropMixin=$__1.DragDropMixin,DropEffects=$__1.DropEffects;

var Box = React.createClass({displayName: 'Box',
  mixins: [DragDropMixin],

  propTypes: {
    id: PropTypes.any.isRequired,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    hideSourceOnDrag: PropTypes.bool.isRequired
  },

  configureDragDrop:function(registerType) {
    registerType(ItemTypes.BOX, {
      dragSource: {
        beginDrag:function(e) {
          return {
            effectAllowed: DropEffects.MOVE,
            item: {
              id: this.props.id,
              startLeft: this.props.left,
              startTop: this.props.top,
              startPageX: e.pageX,
              startPageY: e.pageY
            }
          };
        }
      }
    });
  },

  render:function() {
    var $__0=    this.getDragState(ItemTypes.BOX),isDragging=$__0.isDragging,
        $__1=    this.props,hideSourceOnDrag=$__1.hideSourceOnDrag;

    if (isDragging && hideSourceOnDrag) {
      return null;
    }

    return (
      React.createElement("div", React.__spread({},  this.dragSourceFor(ItemTypes.BOX), 
           {style: {
            position: 'absolute',
            left: this.props.left,
            top: this.props.top,
            border: '1px dashed gray',
            padding: '0.5rem'
           }}), 
        this.props.children
      )
    );
  }
});

module.exports = Box;


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-naive/Box.js
 ** module id = 136
 ** module chunks = 0
 **/